import React from "react";

const VProdshopContext = React.createContext(undefined);
const SizeContext = React.createContext(undefined);

export {VProdshopContext, SizeContext};
